var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isAssetTuned)?_c('div',{staticClass:"wt-editor-modal",attrs:{"id":"assetEditor"}},[_c(_vm.modalType,{tag:"component",attrs:{"overlay-guid":_vm.overlayGuid},on:{"close":_vm.closeModal}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }